import { useCallback, useEffect, useState } from 'react';
import { listCooldownAccounts, liftCooldown, type CooldownAccount, type PaginatedResult } from '../api/admin';

export function useAdminCooldown(params?: { page?: number; pageSize?: number; search?: string }) {
  const [data, setData]       = useState<PaginatedResult<CooldownAccount> | null>(null);
  const [loading, setLoading] = useState(true);
  const [lifting, setLifting] = useState<number | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await listCooldownAccounts(params);
      setData(res.data.data);
    } finally {
      setLoading(false);
    }
  }, [params?.page, params?.pageSize, params?.search]);

  useEffect(() => {
    refresh().catch(() => setData(null));
  }, [refresh]);

  const lift = useCallback(async (id: number) => {
    setLifting(id);
    try {
      await liftCooldown(id);
      await refresh();
    } finally {
      setLifting(null);
    }
  }, [refresh]);

  return { data, loading, lifting, refresh, lift };
}
